import { useRecordContext } from 'react-admin';
import React from 'react';

import { MarkupRateSection } from './MarkupRateSection';

export const MarkupRateSectionWrapper = () => {
    const record = useRecordContext();
    return <MarkupRateSection sponsoredSettingId={record?.id} industryId={record?.industry_id} isCreateMode={false} />;
};